import { merge as _merge } from 'lodash'
import es from 'core/translations/es'

export default _merge(es, {})
